
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("99rcJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $3gadb = parcelRequire("3gadb");


var $8DN9t = parcelRequire("8DN9t");


var $9x2sR = parcelRequire("9x2sR");


var $1NBp8 = parcelRequire("1NBp8");


var $luv00 = parcelRequire("luv00");


var $2U9QW = parcelRequire("2U9QW");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1ytiN = parcelRequire("1ytiN");


var $dPJCf = parcelRequire("dPJCf");

const $544e89ef74bbdb03$export$5bc2ad8fe7e5e700 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const showTCNav = edition === (0, $euL71.ConfluenceEdition).STANDARD ? isSiteAdmin : true;
    let t0;
    if ($[0] !== props || $[1] !== showTCNav) {
        t0 = showTCNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($544e89ef74bbdb03$var$CalendarsLinkInner, props) : null;
        $[0] = props;
        $[1] = showTCNav;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $544e89ef74bbdb03$var$CalendarsLinkInner = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { onClick: onClick } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSelected = (0, $dPJCf.useRouteName)($544e89ef74bbdb03$var$isOnSCalendarsRoute);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $544e89ef74bbdb03$var$i18n.calendarsTooltip);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== spaceKey) {
        t2 = (0, $1NBp8.SPACE_CALENDARS).toUrl({
            spaceKey: spaceKey
        });
        $[1] = spaceKey;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
            label: "",
            color: "currentColor"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $544e89ef74bbdb03$var$i18n.calendars);
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2U9QW.PremiumLozengeLoadable), null);
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] !== isSelected || $[7] !== onClick || $[8] !== ssrPlaceholderIdProp || $[9] !== t2) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "top",
            content: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: t2,
            onClick: onClick,
            elemBefore: t3,
            isSelected: isSelected,
            "data-vc": "team-calendar-navigation",
            ...ssrPlaceholderIdProp
        }, t4, t5));
        $[6] = isSelected;
        $[7] = onClick;
        $[8] = ssrPlaceholderIdProp;
        $[9] = t2;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
};
const $544e89ef74bbdb03$var$isOnSCalendarsRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_CALENDARS).name || routeName === (0, $1NBp8.SPACE_CALENDARS_SUBCALENDAR).name
};
const $544e89ef74bbdb03$var$i18n = (0, $h82at.defineMessages)({
    calendarsTooltip: {
        id: "side-navigation.space-navigation.calendars.tooltip",
        defaultMessage: "View calendar"
    },
    calendars: {
        id: "side-navigation.space-navigation.calendars",
        defaultMessage: "Calendars"
    }
});
module.exports["CalendarsLink"] = $544e89ef74bbdb03$export$5bc2ad8fe7e5e700;

});

parcelRegister("2U9QW", function(module, exports) {
$parcel$export(module.exports, "PremiumLozengeUi", () => (parcelRequire("gkc4E")).PremiumLozenge);

var $jmjWc = parcelRequire("jmjWc");


var $gkc4E = parcelRequire("gkc4E");


const $ea97352de2ccf604$export$62673719cbe80cd0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "cJMmb",
    name: "PremiumLozengeLoadable",
    loader: async ()=>(await (parcelRequire("nSyLX"))).PremiumLozenge
});
module.exports["PremiumLozengeLoadable"] = $ea97352de2ccf604$export$62673719cbe80cd0;

});

parcelRegister("nSyLX", function(module, exports) {

let $047c788bdeb73d49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $047c788bdeb73d49$var$load("4yUSc").then(()=>parcelRequire('9xi4O'));

});

parcelRegister("gkc4E", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $5nBzc = parcelRequire("5nBzc");

const $6eab09cc616c0de0$var$messages = (0, $h82at.defineMessages)({
    premium: {
        id: "trial-components.lozenge.premium",
        defaultMessage: "Premium"
    }
});
const $6eab09cc616c0de0$export$b37ef9640eaa3746 = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "discovery",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $6eab09cc616c0de0$var$messages.premium));
};
module.exports["PremiumLozenge"] = $6eab09cc616c0de0$export$b37ef9640eaa3746;

});


//# sourceMappingURL=CalendarsLink.3ee1308e.js.map
